import CN from "classnames";
import * as Yup from "yup";
import { useState } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "../../components/Button";
// import ImageUpload, { Image } from "./plugins/ImageUpload";
import { useSelector } from "react-redux";
import store from "../../store/store";
import { Oval } from "react-loader-spinner";
import { PiEyeFill, PiEyeSlashFill } from "react-icons/pi";
import { signUpNewUser } from "../../store/reducers/auth/authSlice";
// import { BsEyeFill } from "react-icons/bs";

interface FormValues {
  // active: boolean;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  defaultStatus: boolean;
  role: string;
}

export const AddOffer: React.FC<any> = () => {
  const [viewPassword, setViewPassword] = useState(false);
  const { isLoading } = useSelector((state: any) => state.rootReducer?.auth);

  const navigate = useNavigate();

  // Validation schema
  const validationSchema = Yup.object({
    firstName: Yup.string()
      .required("First Name is required")
      .max(10, "Offer Name must be 10 characters or less"),
    lastName: Yup.string()
      .required("Last Name is required")
      .max(10, "Last Name must be 10 characters or less"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .max(40, "Password must not exceed 40 characters"),
    role: Yup.string(),
  });

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    errors,
    touched,
  } = useFormik<FormValues>({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      defaultStatus: false,
      role: "superadmin",
    },
    validationSchema,
    onSubmit: (values: FormValues) => {
      const data = {
        firstName: values.firstName, // Convert string to boolean
        lastName: values.lastName,
        email: values.email,
        password: values.password,
        defaultStatus: values.defaultStatus,
        role: values.role,
      };

      // console.log("formData", formData);
      // const data = {
      //   active: true,
      //   name: "offer 2",
      //   type: "percentage-discount",
      //   expireDate: "2025-12-12 15:30:45",
      //   discountPercentage: 100,
      // };

      // addProductContext?.addNewProduct(formData);
      store.dispatch(signUpNewUser(data));
    },
  });

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <form onSubmit={handleSubmit}>
        <div className="lg:grid grid-cols-2 flex flex-col gap-6 my-4 py-8 lg:mx-8 mx-4">
          {/* Brand Name */}
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              First Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="firstName"
              value={values.firstName}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="First Name"
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.firstName && touched.firstName
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.firstName && touched.firstName && (
              <p className="text-red-500 text-sm my-2">{errors.firstName}</p>
            )}
          </div>

          {/* Description */}
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              Last Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="lastName"
              value={values.lastName}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Last Name"
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.lastName && touched.lastName
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.lastName && touched.lastName && (
              <p className="text-red-500 text-sm my-2">{errors.lastName}</p>
            )}
          </div>

          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              Email <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Email"
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.email && touched.email
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.email && touched.email && (
              <p className="text-red-500 text-sm my-2">{errors.email}</p>
            )}
          </div>

          {/* country Name */}
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              Password <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <input
                type={`${viewPassword ? "text" : "password"}`}
                name="password"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Password"
                className={CN(
                  "block w-full p-3 border rounded-md",
                  errors.password && touched.password
                    ? "border-red-500"
                    : "border-primary1"
                )}
              />
              <div className="absolute top-[50%] transform -translate-y-1/2 right-4 cursor-pointer">
                {viewPassword ? (
                   <PiEyeFill onClick={() => setViewPassword(!viewPassword)} />
                ) : (
                  <PiEyeSlashFill
                    onClick={() => setViewPassword(!viewPassword)}
                  />
                )}
              </div>
            </div>
            {errors.password && touched.password && (
              <p className="text-red-500 text-sm my-2">{errors.password}</p>
            )}
          </div>
          <div className="col-span-2 flex items-start">
            <input
              type="checkbox"
              name="defaultStatus"
              className="accent-primary1 w-[18px] h-[18px] mr-3 my-1 cursor-pointer rounded border border-primary1"
              onChange={(e) => setFieldValue("defaultStatus", e.target.checked)}
              checked={values.defaultStatus}
            />
            <div className="flex flex-col gap-1 mb-2">
              <label className="block text-base font-semibold">
                Set as Default Admin
              </label>
              <span className="font-normal text-sm">
              Default admin can't be deactive
              </span>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div
          className={`flex justify-end flex-row gap-4 mt-5 py-4 w-full sticky bottom-0 bg-primary2 lg:px-8 px-4`}
        >
          <div className="col-span-2 flex justify-end gap-5">
            <Button onClick={() => navigate("/admins")} apparence="gray">
              Cancel
            </Button>

            <Button
              isLoading={isLoading.signUpData}
              view="default"
              type="submit"
            >
              <div className="flex gap-1">
                {isLoading.signUpData && (
                  <Oval
                    height={18}
                    width={18}
                    color="#ffff"
                    wrapperStyle={{}}
                    wrapperClass="max-sm:mt-[3.5px] mt-[5.2px] max-lg:mt-[5.2px]"
                    visible={true}
                    ariaLabel="oval-loading"
                    secondaryColor="gray-primary"
                    strokeWidth={6}
                    strokeWidthSecondary={6}
                  />
                )}
                <div className="font-normal text-base">Save</div>
              </div>
            </Button>
          </div>
        </div>
      </form>
    </motion.div>
  );
};

export default AddOffer;
